document.addEventListener('DOMContentLoaded', () => {
  const desktopTopBar = document.querySelector('.desktop-top-bar');

  const getHeaderHeight = () => desktopTopBar ? desktopTopBar.offsetHeight : 0;

  const syncStickyTop = () => {
    const height = getHeaderHeight();
    if (height > 0) {
      document.documentElement.style.setProperty('--article-sticky-top', `${height}px`);
    }
  };

  syncStickyTop();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncStickyTop, 150);
  }, { passive: true });

  const copyPageUrl = async (trigger) => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      trigger.dataset.copied = 'true';
    } catch (error) {
      console.error('Copy link failed:', error);
      trigger.dataset.copied = 'error';
    }
    setTimeout(() => delete trigger.dataset.copied, 2000);
  };

  document.addEventListener('click', (event) => {
    const copyTrigger = event.target.closest('[data-copy-page-url]');
    if (!copyTrigger) return;
    event.preventDefault();
    copyPageUrl(copyTrigger);
  });

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  if (isMobile) {
    const socialLinks = document.querySelector('[data-social-links]');
    const socialLinksMobile = document.querySelector('[data-social-links-mobile]');
    if (socialLinks && socialLinksMobile) {
      socialLinksMobile.appendChild(socialLinks);
    }
  }

  const articleBody = document.querySelector('[data-article-body]');

  if (articleBody) {
    articleBody.querySelectorAll('p').forEach((p) => {
      if (p.innerHTML.trim() === '&nbsp;' || p.textContent === ' ') {
        p.remove();
      }
    });

    // Rich-text tables (often pasted from Word/Docs) need their own scroll
    // container so a many-column table can keep legible columns and scroll
    // horizontally instead of being squeezed to fit the viewport.
    articleBody.querySelectorAll('table').forEach((table) => {
      if (table.parentElement.classList.contains('article-content__table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'article-content__table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  const tocList = document.querySelector('[data-toc-list]');

  if (!articleBody || !tocList) return;

  const headings = [...articleBody.querySelectorAll('h2')];

  if (headings.length === 0) return;

  const fragment = document.createDocumentFragment();
  const tocLinks = [];
  const tocLinkMap = new Map();

  headings.forEach((heading, index) => {
    const slugText = heading.textContent
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    const id = `toc-${index}-${slugText}`;
    heading.id = id;

    const li = document.createElement('li');
    li.className = 'article-content__toc-item';

    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = heading.textContent.trim();
    a.className = 'article-content__toc-link';
    a.dataset.tocLink = id;

    li.appendChild(a);
    fragment.appendChild(li);
    tocLinks.push(a);
    tocLinkMap.set(id, a);
  });

  tocList.appendChild(fragment);

  tocLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.dataset.tocLink;
      const target = document.getElementById(targetId);
      if (!target) return;
      const stickyOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--article-sticky-top')) || 164;
      const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  let activeTocLink = null;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        if (activeTocLink) activeTocLink.removeAttribute('data-active');
        activeTocLink = tocLinkMap.get(entry.target.id) ?? null;
        if (activeTocLink) activeTocLink.dataset.active = 'true';
      });
    },
    { rootMargin: '-10% 0px -80% 0px', threshold: 0 }
  );

  headings.forEach((heading) => observer.observe(heading));

  if (isMobile) {
    const preContent = document.querySelector('[data-pre-content]');
    const sidebarLeft = document.querySelector('.article-content__sidebar-left');
    const bodyWrapper = document.querySelector('.article-content__body');

    if (preContent && sidebarLeft && bodyWrapper) {
      const firstH2 = articleBody.querySelector('h2');

      if (firstH2) {
        const mobileFragment = document.createDocumentFragment();
        let node = articleBody.firstChild;
        while (node && node !== firstH2) {
          const next = node.nextSibling;
          mobileFragment.appendChild(node);
          node = next;
        }
        preContent.appendChild(mobileFragment);
      }

      bodyWrapper.insertBefore(sidebarLeft, articleBody);
    }
  }

  const tocToggle = document.querySelector('[data-toc-toggle]');
  const tocWrapper = document.querySelector('[data-toc-wrapper]');

  if (!tocToggle || !tocWrapper) return;

  tocToggle.addEventListener('click', () => {
    const isOpen = tocWrapper.dataset.open === 'true';
    tocWrapper.dataset.open = isOpen ? 'false' : 'true';
    tocToggle.setAttribute('aria-expanded', String(!isOpen));
  });
});
